import React from 'react'
import XCancel from './XCancel'
import Image01 from "../assets/svg/mygroup.svg";
import { MdGroups } from 'react-icons/md';
import { useGroup } from '../context/GroupContext';
import { auth } from '../firebase/firebase';
import Image02 from "../assets/profile.svg";

export default function GroupInfo({ close}) {
    const { openedGroup } = useGroup();
  return (
    <>
        {" "}
        <div className="pb-[32px] w-[300px] md:w-[536px] h-[auto] relative px-0">
            <span className='absolute p-0 m-0 z-40 text-white -top-3 -right-3'>
                <XCancel close={close} />
            </span>
            <div className="w-full">
                  <div className="relative mb-4">
                      <div className='absolute top-0 l-0 w-full h-full rounded-xl' style={{
                          backgroundColor: 'rgba(0,0,0,.6)'
                      }}></div>
                      <div className="absolute bottom-4 left-0 px-4">
                          <h4 className='text-white text-xl font-semibold'>{openedGroup?.groupName}</h4>
                          <p className="mt-2 text-white text-sm">{openedGroup?.description}</p>
                      </div>
                      <img src={openedGroup?.image || Image01} alt='' className='rounded-xl object-cover w-full h-52' srcset="" />
                  </div>
            </div>
            <div className="px-[20px] h-full flex flex-col justify-center">
                <div className="flex items-center gap-1 mb-3">
                    <MdGroups className="text-xl text-primary" />
                    <h4 className="text-sm font-semibold">Members</h4>
                </div>
                <div className="max-h-80 overflow-y-scroll">
                      {openedGroup?.members?.map((member) => {
                          return member?.userId !== auth?.currentUser?.uid && <div key={openedGroup?.members?.indexOf(member)} className={`flex py-2 border-b items-center gap-2 ${openedGroup?.members?.indexOf(member) !== openedGroup?.members?.length - 1 && 'border-gray-400'}`}>
                            <img alt='' className="w-14 h-14 rounded-full" src={member.profilePicture || Image02} />
                            <div>
                                <h4 className='text-sm font-semibold'>{member?.firstName + " " + member?.lastName}</h4>
                                <p className='text-xs'>{`${member?.city}, ${member?.state}`}</p>
                            </div>
                        </div>;
                      })}
                    
                </div>
            </div>
        </div>
    </>
  )
}
